export default __webpack_public_path__ + "static/media/map-home.f5dcc995.svg";